/* eslint indent: 0 */

import './embedded_recorder.less';

import extend from 'lodash/extend';
import includes from 'lodash/includes';
import isNil from 'lodash/isNil';
import bind from 'lodash/bind';
import Backbone from 'backbone';

import embeddedRecorderTemplate from './embedded_recorder.tpl';
import embeddedRecorderUiTemplate from './embedded_recorder_ui.tpl';

  /* 
    things that should be improved, at some point:

    better state while waiting for you to accept the recorder 
    (especially on firefox, where an error might not trigger)

    Error message design

    Safari and IE support, once they add the MediaRecorderAPI 
  */
  
const EmbeddedRecorder = Backbone.View.extend({
    
    className: 'zoomforth-recorder',
    
    events: {
      // exit
      'click .zfr-action-exit': 'exitRecorder',
      
      // recording steps
      'click .zfr-action-request-camera': 'setupRecorder',
      'click .zfr-action-start-countdown': 'startCountdown',
      'click .zfr-action-cancel-countdown': 'cancelCountdown',
      'click .zfr-action-stop-recording': 'stopRecording',
      'click .zfr-action-skip-playback': 'doneVideoPlayback',
      
      // post-recording options
      'click .zfr-action-start-playback': 'startVideoPlayback',
      'click .zfr-action-accept-video': 'acceptRecordedVideo',
      'click .zfr-action-record-again': 'recordAgain'
      
    },
    
    getDefaultOptions : function() {
      return {
        'maxDuration': 180,
        'countdown': 3,
        'showTips': true
      };
    },
        
    initialize: function(argOptions) {
      /*
        options = {
          maxDuration: (optional) maximum number of seconds for recording
          countdown: (optional) how many seconds to count down from
        }
      
      */
      
      // we may call initalize multiple times on this 
      // -- it's how we record again.
      // make sure we remember the options that were originally passed in,
      // and we unbind listenign to itself
      this.stopListening(this);
      
      if (isNil(this._initial_options)) {
        this._initial_options = argOptions;
      } else {
        argOptions = this._initial_options;
      }
      
      var options = extend({}, this.getDefaultOptions(), argOptions);
      
      // Configuration
      this.maxDuration = parseInt(options.maxDuration);
      this.countdownSeconds = parseInt(options.countdown);
      this.showTips = !!options.showTips;

      // Recording internals
      this.recorder = null;
      this.stream = null;
      this.recordedBlob = null;
      this.blobChunks = [];
      
      // Video Nodes
      this.recordNode = null;
      this.$playbackNode = null;
      
      // Timeouts and Intervals
      this.recorderTimeout = null;
      this.countdownTimeout = null;
      this.recordingTimerInterval = null;
      this.recordingTimeStart = null;
      
      // State
      this.errorName = null; // null or name of error
      this._removed = false;
      this.state = 'prerender';
      
      // Events
      this.listenTo(this, 'state-change', function () {
        this.renderUI();
      });

    },
    
    remove: function() {
      this._removed = true;
      this.clearPersistentState();
      EmbeddedRecorder.__super__.remove.call(this);
    },
    
    clearPersistentState: function() {
      this._deactivateStream();
      // just in case the reference sticks around, this makes sure
      // we will not be a memory hog
      this.recordedBlob = null;
      this.blobChunks = [];
      this._unbindKeyActions();
      window.clearTimeout(this.recorderTimeout);
      window.clearTimeout(this.countdownTimeout);
      window.clearInterval(this.recordingTimerInterval);
    },
    
    _deactivateStream: function() {
      if (!this.stream) {
        return;
      }
      if (this.stream.getVideoTracks()[0]) {
        try {
          this.stream.getVideoTracks()[0].stop();
        } catch (e) {
          window.console.warn('Unable to stop() video stream track');
        }
      }
      if (this.stream.getAudioTracks()[0]) {
        try {
          this.stream.getAudioTracks()[0].stop();
        } catch (e) {
          window.console.warn('Unable to stop() audio stream track');
        }
      }
    },
    
    _unbindKeyActions: function() {
      $(window).unbind('keyup.zfrecorder');
    },
    
    _bindKeyActions: function() {

      $(window).bind('keyup.zfrecorder', (e)=> {
        if (e.keyCode === 32 && this.$('.zfr-main-button').length) {
          this.$('.zfr-main-button').click();
        } else if (e.keyCode === 27) {
          if (this.state === 'recording') {
            this.stopRecording();
          } else {
            this.exitRecorder();
          }
        }
      });
    },
    
    render: function(){
      if (this._removed) {
        throw Error('this recorder cannot be rendered, it has already been disabled');
      }
      if (this.state != 'prerender') {
        throw Error(
          'EmbeddedRecorder can only be rendered after being reset to initial state.' +
          ' try calling renderUI'
        );
      }
            
      this.$el.html(embeddedRecorderTemplate({}));
      
      if (!EmbeddedRecorder.canBeUsed()) {
        this.updateState('bad_browser');
        return;
      }
      
      this._bindKeyActions();
      if (this.showTips) {
        this.updateState('initial');
      } else {
        this.setupRecorder();
      }
    },
    
    renderUI: function() {
      this.$el.attr('class', this.className + ' zfr-state-' + this.state);
      
      this.$('.zfr-ui-wrapper').html(embeddedRecorderUiTemplate({
        includes: includes, // hack
        state: this.state,
        error: this.errorName,
        maxDuration: this.maxDuration
      }));
      this.$('.zfr-ui-wrapper').attr('class', 'zfr-ui-wrapper');
    },

    
    // state should rarely be used for lower level stuff,
    // mainly for UI
    updateState: function(newState){
      if (!includes([
        'prerender',
        'initial',
        'waiting-for-camera',
        'waiting-to-record',
        'countdown',
        'recording',
        'recorder-cleanup',
        'recording-complete',
        'playback',
        'error',
        'bad_browser'
      ], newState)) {
        throw '"' + newState + '" is not a valid state';
      }
      
      if (this.state != newState) {
        this.state = newState;
        this.trigger('state-change', newState);
      }
    },
    
    /*
      request access to the webcam, via chrome
    
      right now we rely on the webrtc adapter shim to make chrome work properly
      (and other browsers in the future)
    */
    setupRecorder: function() {
      
      var streamConstraints = {
        video: true,
        audio: true
      };
      
      this.updateState('waiting-for-camera');
      
      this.recordNode = this.$('video.zfr-record').get(0);
            
      // TODO: firfox sometimes does not complete this promise, should set a timeout

      navigator.mediaDevices.getUserMedia(streamConstraints) // shimmed
      
        .then((stream)=> {
          
          // we do not care if they existed the recorder
          if (this._removed) {
            return;
          }
          
          // make sure we have both the video and the audio
          if (!stream.getAudioTracks()[0]) {
            this.triggerError('FailedToLoadMicrophone');
            return;
          } 
          if (!stream.getVideoTracks()[0]) {
            this.triggerError('FailedToLoadCamera');
            return;
          }
          
          // getUserMedia returns a deferred that has the stream object
          this.stream = stream;
          this.stream.onended = function() {
            // what even causes this ...?
            this.trigger('stream-ended');
          };
          this.recordNode.srcObject = this.stream; // srcObject is shimmed
          
          this.recorder = new MediaRecorder(this.stream);
          this.recorder.ondataavailable = bind(this.handleRecordedBlobChunk, this);

          this.updateState('waiting-to-record');
        })
        
        .catch((error)=> {
          // we do not care if they existed the recorder
          if (this._removed) {
            return;
          }
          if (
            includes([
              'ConstraintNotSatisfiedError',
              'PermissionDeniedError',
              'PermissionDismissedError'
            ], error.name)
          ) {
            this.triggerError(error.name);
          } else {
            throw error;
          }
        });
    },
    
    triggerError: function(errorName) {
      // TODO: make these human readbale
      this.errorName = errorName;
      this.trigger('error', this.errorName);
      this.updateState('error');
    },
    
    handleRecordedBlobChunk: function(e) {
      var blob = e.data;
      this.blobChunks.push(blob);
    },

    
    startCountdown: function() {
      
      // defaults to 5 seconds for now, this could potentially be set in options
      var nextCountdownNumber = this.countdownSeconds;
      
      var updateCountdown = ()=> {
        // we may have cancelled the countdown
        if (this._removed) {
          return;
        }
        
        // queue up another countdown, or start recording
        if ( nextCountdownNumber === 0 ) {
          // start recording when we get to zero
          this.startRecording();
        } else {
          // update UX
          this.$('.zfr-countdown-number').text(nextCountdownNumber);
          // recurse after 1 second with a lower countdown number
          nextCountdownNumber -= 1;
          this.countdownTimeout = window.setTimeout(updateCountdown, 1000);
        }
      };
      
      this.updateState('countdown');
      updateCountdown();
    },
    
    cancelCountdown: function() {
      window.clearTimeout(this.countdownTimeout);
      this.updateState('waiting-to-record');
    },
    
    startRecording: function() {
      if (!this.recorder) {
        throw new Error('recording begun before recorder was prepared');
      }
      
      this.recorderTimeout = window.setTimeout(
        bind(this.stopRecording, this),
        this.maxDuration * 1000
      );
      
      this.recorder.start(1000);
      
      this.updateState('recording');
      
      window.clearInterval(this.recordingTimerInterval);
      this.recordingTimeStart = new Date();
      this.recordingTimerInterval = window.setInterval(bind(this.onRecorderTick, this), 10);
    },
    
    onRecorderTick: function() {
      var secondsIntoRecording = ((new Date()) - this.recordingTimeStart) / 1000;
      this.$('.zfr-current-recording-second').text(secondsIntoRecording.toFixed(0));
    },

    stopRecording: function() {
      /*
        thw timing on this chunk aggregation is bizarre -- chrome will keep firing 
        events for a while after it starts, and fires tons of events during,
        whereas firefox will obey the spec and perform exactly one event, but after
        significant latency after stop is called. 
      
        setting up a promise helps mitigate the weirdness.
      */
      if (!this.recorder) {
        throw new Error('stop recording button clicked without a recorder object');
      }
      
      var gotLastChunk = $.Deferred();
      
      window.clearTimeout(this.recorderTimeout);
      window.clearInterval(this.recordingTimerInterval);
      
      // set up final listener to resolve a promise
      this.recorder.ondataavailable = (e)=> {
        this.handleRecordedBlobChunk(e);
        gotLastChunk.resolve();
      };
      
      this.recorder.stop();
      this.updateState('recorder-cleanup');
      
      // once we have the last chunk, make a blob of all the chunks,
      // stop the recording, and set up the playback node
      gotLastChunk.done(()=> {
        if (this._removed) {
          return;
        }
        
        // TODO: optimize memory usage
        // blobs are immutable, so we need to have all the blob chunks
        // available to do this, and it doubles the memory footprint.
        // some strategies include finding a way to stream the blob chunks, 
        // or finding a way to save to disk.
        this.recordedBlob = new Blob(this.blobChunks, {
          type: 'video/webm'
        });
        this.blobChunks = [];

        if (this.recordedBlob.size === 0) {
          alert([
            'ERROR - RECORDING FAILED (restart browser to fix this)\n\n',
            'As part a smooth recording experience, we rely on advanced browser features. ',
            'Unfortunately, these features are more prone to failure, and there was an error in this recording.\n\n',
            'You can fix this by completely restarting your web browser -- ',
            'recording should function correctly afterwards.\n\n',
            'If it does not, please contact support@zoomforth.com.\n\nWe\'re sorry for this inconvenience.'
          ].join(''));
          throw new Error('Error creating recording file. File size 0.');
        }
        
        this.recordedBlobUrl = URL.createObjectURL(this.recordedBlob);
        this._deactivateStream();
        $(this.recordNode).remove();
        this.updateState('recording-complete');
      
        this.$playbackNode = this.$('.zfr-playback');
        this.$playbackNode.attr('src', this.recordedBlobUrl);
      });
    },
    
    startVideoPlayback: function() {
      if (!this.recordedBlobUrl) {
        throw new Error('video playback attempted before recording was finished');
      }
      // cannot use backbone delegation for video events
      this.$playbackNode.unbind('ended').bind('ended', bind(this.doneVideoPlayback, this));
      this.$playbackNode.get(0).play();
      this.updateState('playback');
    },
    
    doneVideoPlayback: function() {
      this.$playbackNode.get(0).load();
      this.updateState('recording-complete');
    },
    
    recordAgain: function(){
      // completely reset the state
      this.clearPersistentState();
      this.initialize();
      this.render();
      this.setupRecorder();
    },
    
    acceptRecordedVideo: function() {
      this.trigger('ready-to-save-video', this.recordedBlob);
    },
    
    exitRecorder: function() {
      this.remove();
      this.trigger('exited');
    }
    
    
    // download: function() {
    //   // not exposed in the ux for now, but it might be fun to let people download it directly, without submitting, at some point
    //   if (!this.recordedBlobUrl) {
    //     throw new Error('download attempted before recording was finished');
    //   }
      
    //   var a = document.createElement('a');
    //   document.body.appendChild(a);
    //   a.style = 'display: none';
    //   a.href = this.recordedBlobUrl;
    //   a.download = 'recorded.webm';
    //   a.click();
    //   window.URL.revokeObjectURL(url);
    // }
    
    
  }, {
    /*
      {
        fullWindow: take over the whole window?
        OR
        container: DOM node to contain this, or jquery node or selector string
        recorderOptions: what to pass into recorder
      }
    
    */
    create: function(options) {
      var $container;
      var recorderOptions = options.recorderOptions || {};
      
      if (options.fullWindow) {
        $container = $('body');
      } else {
        $container = $(options.container);
      }
      var recorder = new EmbeddedRecorder(recorderOptions);
      $container.append(recorder.$el);
      if (options.fullWindow) {
        recorder.className = recorder.className + ' zfr-is-full-window';
      }
      recorder.render();
      return recorder;
    },
    
    canBeUsed: function() {
      return !isNil(window.MediaRecorder);
    }
  });

export default EmbeddedRecorder;
  